<script setup lang="ts">
const { init } = useIntegrations()
useGlobalCallbacks()
init()
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="var(--accent-color)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
